<loading [visible]="saving()"></loading>

@if(!loading()){
<form [formGroup]="saveForm" (submit)="false"
  class="flex flex-col gap-2 min-h-[calc(100dvh-4rem)] max-w-7xl mx-auto">

  @if (pendingSyncEntry) {
  <div class="rounded-lg border border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-800">
    Guardado localmente, pendiente de sincronizar con el servidor.
  </div>
  }

  <section class="bg-white border border-slate-200 rounded-2xl shadow-sm">

    <div
      class="flex flex-row flex-wrap items-center justify-between px-4 py-2.5 bg-slate-50/50 border-b border-slate-100 gap-3">

      <div class="flex flex-row items-center gap-3">
        <div class="flex flex-col">
          <span class="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">Documento</span>
          <span class="text-xl font-bold text-slate-800">Ticket</span>
        </div>
        <div class="block h-7 w-px bg-slate-200 mx-1"></div>

        <div
          class="flex flex-wrap items-center gap-2 bg-white px-3 py-1.5 rounded-xl border border-slate-100 shadow-sm group cursor-pointer transition-all hover:border-blue-200">

          <div class="text-left relative min-w-15">
            <p class="text-[9px] font-medium text-slate-400 uppercase leading-none mb-0.5">ID / Año</p>

            <p class="text-xs font-bold text-slate-700 group-hover:hidden transition-all">
              {{saveForm.get('id_by_company')?.value?.toString().padStart(4, '0')}} / {{saveForm.get('year')?.value}}
            </p>

            <div class="hidden group-hover:flex items-center gap-1 animate-in fade-in zoom-in duration-200">
              <span class="text-xs font-bold">
                {{saveForm.get('id_by_company')?.value?.toString().padStart(4,'0')}}
              </span>
              <span class="text-xs text-slate-300">/</span>
              <input type="number" formControlName="year"
                class="w-12 p-0 text-xs font-bold text-blue-600 border-none bg-blue-50 rounded focus:ring-0">
            </div>
          </div>

          <div class="text-left pl-1 relative min-w-20">
            <p class="text-[9px] font-medium text-slate-400 uppercase leading-none mb-0.5">Vendedor</p>

            <p class="text-xs font-bold text-slate-700 italic group-hover:hidden transition-all">
              {{showSeller()}}
            </p>

            <div class="hidden group-hover:block animate-in fade-in zoom-in duration-200">
              <select formControlName="user_id">
                @for (user of this.dropdowns.users; track $index) {
                <option [value]="user.id">
                  {{user.name}}
                </option>
                }
              </select>
            </div>
          </div>

          <div class="text-left pl-1 relative min-w-20">
            <p class="text-[9px] font-medium text-slate-400 uppercase leading-none mb-0.5">Oficina</p>

            <p class="text-xs font-bold text-slate-700 italic group-hover:hidden transition-all">
              {{showOfficeName()}}
            </p>

            <div class="hidden group-hover:block animate-in fade-in zoom-in duration-200">
              <select formControlName="office_id">
                @for (office of dropdowns.offices; track $index) {
                <option [value]="office.id">
                  {{office.name}}
                </option>
                }
              </select>
            </div>
          </div>

          @if(dropdowns.ibans.length > 0){
          <div class="text-left pl-1 relative min-w-24">
            <p class="text-[9px] font-medium text-slate-400 uppercase leading-none mb-0.5">IBAN</p>

            <p class="text-xs font-bold text-slate-700 italic group-hover:hidden transition-all">
              {{showIbanLabel()}}
            </p>

            <div class="hidden group-hover:block animate-in fade-in zoom-in duration-200">
              <select formControlName="iban">
                <option [value]="null">— Ninguno —</option>
                @for (item of dropdowns.ibans; track $index) {
                <option [value]="item.iban">
                  {{item.label}}
                </option>
                }
              </select>
            </div>
          </div>
          }

        </div>
      </div>

      <div class="flex items-center gap-3">
        <button type="button" (click)="openCashDrawer()"
          class="py-2 px-4 bg-slate-800 text-white hover:bg-slate-700 rounded-xl font-bold text-[10px] tracking-widest transition-all uppercase whitespace-nowrap">
          Abrir caja
        </button>

        <label for="tax_included" class="text-[10px] font-bold text-slate-400 uppercase tracking-widest cursor-pointer">
          Precio con IVA incluido
        </label>
        <input type="checkbox" id="tax_included" formControlName="tax_included"
          class="w-5 h-5 text-black border-2 border-black rounded focus:ring-black accent-black cursor-pointer">
      </div>
    </div>
  </section>

  @if(showMixPayModal) {
  <app-custom-modal customTitle="Pago mixto" maxWidth="5xl" [hideFooter]="true" (closeFunction)="closeMixPayModal()">
    <div formArrayName="mix_pay" class="flex flex-col gap-2">
      @for(mix of mixPayControls; track mix; let i = $index) {
      <div [formGroupName]="i" class="flex flex-row items-end gap-3">
        <div class="flex-1">
          <custom-select label="Tipo de pago" [formControlItem]="mix.get('type')!" [options]="mixPayMethods"
            bindValue="id" bindLabel="name" [isMultiple]="false" placeholder="Selecciona un método de pago">
          </custom-select>
        </div>

        <div class="flex-1">
          <custom-input label="Cantidad" decimal [formControlItem]="mix.get('quantity')!"></custom-input>
        </div>

        <button type="button" (click)="removeMixPay(i)"
          class="mb-1.5 text-slate-300 hover:text-red-500 outline-none">✕</button>
      </div>
      }

      <button type="button" (click)="addMixPay()"
        class="self-start text-[10px] font-bold text-blue-500 hover:underline uppercase tracking-widest">
        + Añadir método de pago
      </button>
    </div>
  </app-custom-modal>
  }

  <section class="flex-1 flex flex-col bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
    <div class="p-3 border-b border-slate-100 bg-white flex flex-row items-center gap-3">
      <div class="relative flex-1">
        <span class="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">🔍</span>
        <input type="text" #mainSearch (input)="filterProducts($any($event.target).value)" (focus)="openProductSearch()"
          (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); addFirstProduct(mainSearch); showResults = false"
          placeholder="BUSCAR PRODUCTO POR NOMBRE O REFERENCIA..."
          class="w-full pl-12 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-2xl text-sm font-bold text-slate-700 focus:bg-white focus:ring-4 focus:ring-blue-500/10 outline-none transition-all uppercase tracking-wider">
        @if(showResults && filteredProducts.length > 0) {
        <div
          class="absolute z-50 w-full mt-2 bg-white border border-slate-200 rounded-2xl shadow-xl max-h-60 overflow-y-auto p-2">
          @for(prod of filteredProducts; track prod; let lastProd = $last) {
          <button type="button" (click)="selectProductFromSearch(prod, mainSearch)"
            (keydown.tab)="onSearchProductTab($any($event), lastProd)"
            class="w-full flex items-center justify-between p-3 hover:bg-blue-50 rounded-xl text-left transition-colors group">
            <div class="flex flex-col items-start gap-0.5">
              <span class="text-sm font-bold text-slate-700 uppercase">{{ prod.name }}</span>
              <div class="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                <span class="text-[10px] font-bold text-slate-400">REF: {{prod.code}}</span>
                @for(tariff of dropdowns.tariffs; track tariff.id) {
                <span class="text-[10px] font-bold text-slate-400">{{ tariff.name }}: {{ getPrice(prod, tariff.id) }}€</span>
                }
              </div>
            </div>
            <div class="flex flex-col items-end gap-0.5">
              <span class="text-sm font-black text-blue-600">{{ getPrice(prod) }}€</span>
              <span class="text-[10px] font-bold text-slate-400">Stock: {{ prod.stock }}</span>
            </div>
          </button>
          }
        </div>
        }
      </div>

      <button type="button" (click)="openProductCatalog()"
        class="py-3 px-4 bg-slate-800 text-white hover:bg-slate-700 rounded-2xl font-bold text-xs tracking-widest transition-all uppercase whitespace-nowrap">
        Consulta de artículos
      </button>
    </div>

    @if(showProductCatalog) {
    <app-custom-modal customTitle="Catálogo de productos" maxWidth="4xl" [hideFooter]="true" (closeFunction)="closeProductCatalog()">
      <div class="max-h-[60vh] overflow-auto">
        <table class="w-full text-left border-collapse">
          <thead class="sticky top-0 bg-slate-50/90 backdrop-blur-sm text-slate-500 z-10 border-b border-slate-100">
            <tr>
              <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest">Producto</th>
              @for(tariff of dropdowns.tariffs; track tariff.id) {
              <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-right">{{ tariff.name }}</th>
              }
              <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-right w-24">Stock</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-50">
            @for(prod of catalogProducts; track prod.id) {
            <tr (click)="selectProductFromCatalog(prod)" class="hover:bg-blue-50 cursor-pointer transition-colors">
              <td class="px-3 py-2">
                <span class="block text-sm font-bold text-slate-700 uppercase leading-tight">{{ prod.name }}</span>
                <span class="block text-[10px] font-bold text-slate-400">REF: {{ prod.code }}</span>
              </td>
              @for(tariff of dropdowns.tariffs; track tariff.id) {
              <td class="px-3 py-2 text-right font-mono font-bold text-slate-600 text-sm">{{ getPrice(prod, tariff.id) }}€</td>
              }
              <td class="px-3 py-2 text-right font-mono font-bold text-slate-600 text-sm">{{ prod.stock }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </app-custom-modal>
    }

    <div class="flex-1 overflow-auto">
      <table class="w-full text-left border-collapse">
        <thead class="sticky top-0 bg-slate-50/90 backdrop-blur-sm text-slate-500 z-10 border-b border-slate-100">
          <tr>
            <th class="px-4 py-2.5 text-[10px] font-bold uppercase tracking-widest">Producto</th>
            <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-center w-24">Cant.</th>
            <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-right w-32">Precio Un.</th>
            <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-right w-32">Descuento</th>
            <th
              class="hidden md:table-cell px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-right w-32">
              Total Sin IVA</th>
            <th class="px-3 py-2.5 text-[10px] font-bold uppercase tracking-widest text-right w-32">Total</th>
            <th class="w-10"></th>
          </tr>
        </thead>
        <tbody formArrayName="items" class="divide-y divide-slate-50">
          @for (item of itemControls; track item; let i = $index; let last = $last) {

          <tr [formGroupName]="i" [class.bg-yellow-100]="!item.get('product_id')?.value">
            <td class="px-4 py-2">
              @let p = getProductInfo(item.get('product_id')?.value);
              <div class="flex flex-col items-start gap-0.5">

                <div class="group">
                  <span
                    class="group-hover:hidden group-focus-within:hidden text-sm font-bold text-slate-700 uppercase leading-tight">
                    {{ item.get('name')?.value || 'Item Manual' }}
                  </span>

                  <input type="text" formControlName="name" tabindex="-1"
                    class="hidden group-hover:block group-focus-within:block w-full py-1.5 bg-slate-50 border border-slate-200 rounded-lg font-bold text-slate-700 text-sm outline-none">
                </div>

                @if(p?.special_measures){
                <div class="flex flex-wrap gap-1 items-center">
                  @for (m of item.get('special_measures')?.value; track $index) {
                  <span class="text-[9px] font-mono bg-slate-100 text-slate-500 px-1.5 rounded border border-slate-200">
                    {{m.q}} x {{m.h}}x{{m.w}}x{{m.t}}
                  </span>
                  }
                  <button type="button" [attr.tabindex]="(i * 10) + 2"
                    (click)="openMeasures(i, item.get('special_measures')?.value, p.special_measures)"
                    class="text-[9px] font-bold text-blue-500 hover:underline ml-1">Editar medidas</button>
                </div>
                }
              </div>
            </td>

            <td class="px-3 py-2">
              <input type="number" formControlName="quantity" [attr.tabindex]="(i * 10) + 1"
                class="w-full py-1.5 bg-slate-50 border border-slate-200 rounded-lg text-center font-bold text-slate-700 text-sm outline-none">
            </td>

            <td class="px-3 py-2 text-right">
              <span class="flex items-center">
                <input type="text" inputmode="decimal" decimalInput formControlName="price" [attr.tabindex]="(i * 10) + 3"
                  class="w-full py-1.5 bg-transparent text-right font-bold text-sm text-slate-600 outline-none">
                €
              </span>
            </td>

            <td class="px-3 py-2 text-right">
              <span class="flex items-center">
                <input type="number" formControlName="discount" [attr.tabindex]="(i * 10) + 4"
                  (keydown.tab)="onDiscountTab($any($event), last, mainSearch)"
                  class="w-full py-1.5 bg-transparent text-right font-bold text-sm text-slate-600 outline-none"> %
              </span>
            </td>

            <td class="hidden md:table-cell px-3 py-2 text-right font-mono font-bold text-slate-500 text-sm">
              {{ getAndCalculateWithOutTax(item) }}€</td>
            <td class="px-3 py-2 text-right font-mono font-black text-slate-800 text-sm">
              {{ getAndCalculateWithTax(item) }}€
            </td>

            <td class="px-3 py-2 text-center">
              <button type="button" (click)="removeItem(i)" tabindex="-1"
                class="text-slate-300 hover:text-red-500 outline-none">✕</button>
            </td>
          </tr>

          }
        </tbody>
      </table>
    </div>
  </section>

  <section class="bg-white border border-slate-200 rounded-2xl shadow-sm px-4 py-3">
    <div class="flex flex-row items-end gap-3">
      <div class="flex-1">

        <custom-select label="Cliente" [formControlItem]="saveForm.controls['client_id']"
          [options]="dropdowns.clients" bindValue="id" bindLabel="name" bindSubLabel="nif" [isMultiple]="false"
          placeholder="Selecciona un cliente (opcional)" (selectionChange)="changeClient()"
          [createComponent]="clientFormComponent" (itemCreated)="getDropdowns()">
        </custom-select>

      </div>

      <div class="flex-1">
        <custom-input label="Fecha" type="date" [formControlItem]="saveForm.controls['date']"></custom-input>
      </div>

      <div class="flex-1">

        <custom-select label="Método de pago" [formControlItem]="saveForm.controls['payment_method']"
          [options]="paymentMethods" bindValue="id" bindLabel="name" [isMultiple]="false"
          placeholder="Selecciona un método de pago">
        </custom-select>

        @if(isMixedPayment){
        <button type="button" (click)="openMixPayModal()"
          class="mt-1 text-[10px] font-bold text-blue-500 hover:underline uppercase tracking-widest">
          Configurar pago mixto ({{mixPayControls.length}})
        </button>
        }

      </div>
    </div>
  </section>

  <section
    class="sticky bottom-0 z-20 bg-slate-900 rounded-2xl p-3 text-white shadow-2xl shadow-slate-900/40 border border-white/5">
    <div class="flex flex-row items-center justify-between gap-3">

      <div class="flex items-center gap-4 flex-wrap">
        <div class="flex flex-col">
          <span class="text-slate-500 font-bold uppercase text-[9px] tracking-widest">Subtotal</span>
          <span class="text-xl font-bold italic">{{ saveForm.get('subtotal')?.value }}€</span>
        </div>
        <div class="flex items-center bg-white/5 p-1.5 rounded-2xl border border-white/10 gap-3">
          <div class="flex bg-slate-800 p-1 rounded-xl border border-white/5">
            <label class="cursor-pointer">
              <input type="radio" [value]="0" formControlName="discount_absolute_bool" class="peer hidden">
              <span
                class="px-3 py-1 rounded-lg text-[10px] font-bold text-slate-400 peer-checked:bg-blue-600 peer-checked:text-white transition-all">%</span>
            </label>
            <label class="cursor-pointer">
              <input type="radio" [value]="1" formControlName="discount_absolute_bool" class="peer hidden">
              <span
                class="px-3 py-1 rounded-lg text-[10px] font-bold text-slate-400 peer-checked:bg-blue-600 peer-checked:text-white transition-all">€</span>
            </label>
          </div>
          <input type="text" inputmode="decimal" decimalInput formControlName="discount"
            class="w-16 bg-transparent border-none text-right font-black text-white focus:ring-0 p-0 text-xl"
            placeholder="0">
        </div>
      </div>

      <div class="flex items-center gap-4 flex-wrap justify-end">
        <div class="flex items-center gap-3">
          <span
            class="text-[10px] font-bold text-slate-500 uppercase tracking-tighter leading-tight w-min text-right">Total</span>
          <div class="flex items-baseline">
            <span class="text-4xl md:text-5xl font-black tracking-tighter text-blue-400">
              {{ saveForm.get('total')?.value }}
            </span>
            <span class="text-lg ml-1 text-slate-500 font-bold">€</span>
          </div>
        </div>

        <div class="flex items-center gap-2">
          <!-- Calculadora de cambio opcional: para guardar directamente sin ella, cambia los (click) por:
               Ticket regalo → (click)="saveEntity(true)"
               Guardar       → (click)="saveEntity()" -->
          <button (click)="finalize(true)" type="button" [disabled]="saveForm.invalid || saving()"
            class="w-36 py-3 bg-slate-700 text-white hover:bg-slate-600 rounded-xl font-bold text-xs tracking-widest transition-all uppercase shadow-lg shadow-slate-900/20 disabled:opacity-30">
            Ticket regalo
          </button>
          <button (click)="finalize()" type="submit" [disabled]="saveForm.invalid || saving()"
            class="w-36 py-3 bg-blue-600 text-white hover:bg-blue-500 rounded-xl font-bold text-xs tracking-widest transition-all uppercase shadow-lg shadow-blue-900/20 disabled:opacity-30">
            Guardar
          </button>
        </div>
      </div>
    </div>
  </section>

</form>
}

@if(pendingChangePrintGift !== null){
<change-calculator [amountDue]="cashDue" [confirmLabel]="pendingChangePrintGift ? 'Cobrar e imprimir regalo' : 'Cobrar y guardar'"
  (closeFunction)="closeChangeCalculator()" (acceptFunction)="acceptChangeCalculator()"></change-calculator>
}

@if(editMeasures){
<document-special-measures-form [specialMeasures]="specialMeasures" (closeFunction)="toggleEditMeasures()"
  (acceptFunction)="acceptMeasures($event)"></document-special-measures-form>
}
